module.exports = __webpack_public_path__ + "img/plan.cec45d18.png";